import {AdminRuntimeEnvProfile} from '../enum/AdminRuntimeEnvProfile'
import {IEnvironmentPreset} from '../types/IEnvironmentPreset'

type AdminRuntimePresetProfile =
  | AdminRuntimeEnvProfile.Development
  | AdminRuntimeEnvProfile.Staging
  | AdminRuntimeEnvProfile.Production

export function getAdminRuntimePreset(profile: AdminRuntimePresetProfile): IEnvironmentPreset {
  return ENV.EnvironmentPresets?.[profile] || {}
}
